import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_console/settings/projects")({
  component: Outlet,
});
